import { Controller } from '@hotwired/stimulus';

export default class TextOrSelectInputController extends Controller {
  static targets = [
    'selectInput',
    'textInput',
    'selectInputWrapper',
    'textInputWrapper',
  ];

  showTextInput(event) {
    event.preventDefault();
    this.selectInputTarget.disabled = true;
    this.textInputTarget.disabled = false;
    this.textInputTarget.value = '';
    this.selectInputWrapperTarget.classList.add('hidden');
    this.textInputWrapperTarget.classList.remove('hidden');
  }

  showSelectInput(event) {
    event.preventDefault();
    this.selectInputTarget.disabled = false;
    this.textInputTarget.disabled = true;
    this.selectInputWrapperTarget.classList.remove('hidden');
    this.textInputWrapperTarget.classList.add('hidden');
  }
}
